var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5512 6.96031C21.3599 5.90469 20.4487 5.13594 19.3912 4.89594C17.8087 4.56031 14.8799 4.32031 11.7112 4.32031C8.54432 4.32031 5.56869 4.56031 3.98432 4.89594C2.92869 5.13594 2.01557 5.85594 1.82432 6.96031C1.63119 8.16031 1.43994 9.84031 1.43994 12.0003C1.43994 14.1603 1.63119 15.8403 1.87119 17.0403C2.06432 18.0959 2.97557 18.8647 4.03119 19.1047C5.71119 19.4403 8.59119 19.6803 11.7599 19.6803C14.9287 19.6803 17.8087 19.4403 19.4887 19.1047C20.5443 18.8647 21.4556 18.1447 21.6487 17.0403C21.8399 15.8403 22.0799 14.1116 22.1287 12.0003C22.0312 9.84031 21.7912 8.16031 21.5512 6.96031ZM9.11994 15.3603V8.64031L14.9756 12.0003L9.11994 15.3603Z","fill":"black"}));
}

YoutubeInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
